import React from 'react';
import Header from '../components/Frontend/Header';
import Footer from '../components/Frontend/Footer';
import { Link} from 'react-router-dom';
import API from "../api.js";
import { setAlert} from 'action/index.js';
import {store,persistor} from 'store/index';
import SimpleReactValidator from 'simple-react-validator';
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga';
import { Navigate} from "react-router-dom";
import ReactPixel from 'react-facebook-pixel';
import PhoneInputField from "components/Inputs/PhoneInputField";
class Franchise extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name:"",
            educationindustry:"",
            phone:"",
            email:"",
            location:"",
            reason:"",
            experience:"",
            error:[],
            submit:false,
            flag:false,
            lockSubmit:false
        }
        this.validator = new SimpleReactValidator();
    }
    componentDidMount() {
        ReactGA.initialize('UA-157984080-1');
        ReactGA.pageview(window.location.pathname + window.location.search);
        
        ReactPixel.init('197333187452630');
        // ReactPixel.pageView();
    }
    handleChange = (event) => {
        const { name, value } = event.target;
        this.setState({[name]:value});
    }
    submitForm = async(e) =>{
        console.log(this.state);
        if (this.validator.allValid() && !this.state.lockSubmit) {
            this.setState({lockSubmit:true});
            e.preventDefault();
            var bodyFormData = new FormData();
            bodyFormData.append('name', this.state.name);
            bodyFormData.append('phone', this.state.phone);
            bodyFormData.append('email', this.state.email);
            bodyFormData.append('location', this.state.location);
            bodyFormData.append('reason', this.state.reason);
            bodyFormData.append('experience', this.state.experience);
            API({
              method: 'POST',
              url: "post/franchise",
              data:bodyFormData,
            }).then(data => {
                console.log(data);
                this.setState({submit:true,lockSubmit:false,name:'',phone:'',email:'',location:'',reason:'',experience:'',flag:true});
                store.dispatch(setAlert({'flag':true,'type':1,'message':data.data.response.message}));
            }).catch(()=>{
                this.setState({lockSubmit:false});
            });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }
    render(){ 
        if (this.state.flag) {
            return (<Navigate to="/thank-you" replace />);
        } 
        return (
            <React.Fragment>
            <Helmet>
                <title>Own A Franchise | LA Language Academy</title>
                <meta name="description" content="Join our mission to connect the world through languages. Become a LA Language Academy franchise owner and run your own successful language school." />
                <meta name="robots" content="index, follow" />
                <link rel="canonical" href={`https://www.languageacademy.com.au/franchise`} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@languageacademy" />
                <meta name="twitter:title" content="Own A Franchise | LA Language Academy" />
                <meta name="twitter:description" content="Join our mission to connect the world through languages. Become a LA Language Academy franchise owner and run your own successful language school." />
                <meta name="twitter:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
                <meta name="twitter:image:alt" content="LA Language Academy Logo" />
                <meta property="og:url" content={`https://www.languageacademy.com.au/franchise`} />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="Own A Franchise | LA Language Academy" />
                <meta property="og:description" content="Join our mission to connect the world through languages. Become a LA Language Academy franchise owner and run your own successful language school." />
                <meta property="og:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
                <meta property="og:image:alt" content="LA Language Academy Logo" />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
            </Helmet>
            <Header />
             <div className="banner-section franchise-banner">
                <div className="container">
                  <div className="row">
                    <div className="banner-content">
                      <h1 className="primary-heading dark-blue-color">                  
                          <span className="wpl-badge gold-badge text-white">Own A Franchise</span>
                      </h1>
                      <p className="sub-title">
                        We turned our passion into our business. <br className="d-none d-md-block" /> Now it’s your turn.
                      </p>
                      <div className="iframe-video-outer position-relative">
                        {/* <div className="iframe-video-wrapper">
                          <iframe
                            className="iframe-video"
                            src="https://www.youtube.com/embed/6tJN984IoQ4?si=rlOsVJWragJc0zie"
                            title="YouTube video player"
                            frameBorder="0"
                            allowFullScreen
                          ></iframe>
                        </div> */}
                        <div className="banner-img-wrapper mb-0">
                          <img
                            className="banner-img"
                            src="/images/web-new-images/banners/franchise-banner.png"
                            alt="LA"
                          />
                        </div>
                        <img
                            className="emoji1 position-absolute"
                            src="/images/web-new-images/emojis/hand-emoji.png"
                            alt="LA"
                          />
                          <img
                            className="emoji2 position-absolute"
                            src="/images/web-new-images/emojis/emoji-2.png"
                            alt="LA"
                          />
                          <img
                            className="emoji3 position-absolute"
                            src="/images/web-new-images/emojis/smile-icon11.png"
                            alt="LA"
                          />
                          <img
                            className="emoji4 position-absolute"
                            src="/images/web-new-images/emojis/emoji-4.png"
                            alt="LA"
                          />
                      </div>                      
                    </div>
                  </div>
                </div>
              </div>

              <div className='franchise-outer'>
                <div className="franchise-why">
                  <div className="container">
                    <div className="row">
                    <h2 className="primary-heading text-center text-white fw-700">
                    Become part of the <br className="d-block" /> <span className="wpl-badge pte-naati-badge text-white">LA family</span> and turn your <br className="d-none d-md-block" /> passion into a business.
                    </h2>
                    <p className='sub-heading text-center text-white'>Our goal is clear, to help as many students achieve their dreams. <br className='d-none d-lg-block' /> If you are looking forward to helping students achieve their goals and run a business <br className='d-none d-lg-block' /> at the same time, you are at the right place.</p>
                    <div className='franchise-why-content'>
                        <img
                        className="img-fluid"
                        src="/images/web-new-images/why-la-01.png"
                        alt="LA"
                        />
                        {/* <Link to="/auth/register" className="primary-btn">REGISTER NOW <img src="/images/web-new-images/right-arrow.svg" alt="LA" /></Link> */}
                    </div>
                    </div>
                  </div>
                </div>
                <div className="form-page-wrapper franchise-form" id='franchise-form'>
                  <div className="container">
                      <div className="row franchFormInr">
                          <div className="col-sm-12">
                              <h2 className="secondary-heading text-center text-white">Apply Now</h2>
                              <p className="sub-heading text-center text-white">If you want to become a part of ours, please fill out the inquiry<br className='d-none d-md-block' />form below and our team will be in touch with you.</p>
                              <div className="form-content-outer position-relative">
                                {/* <img
                                  className="emoji-img1"
                                  src="/images/web-new-images/emojis/33.png"
                                  alt="LA"
                                />
                                <img
                                  className="emoji-img2"
                                  src="/images/web-new-images/emojis/rocket-icon2.png"
                                  alt="LA"
                                />  */}
                              <div className="form-content">                            
                                  <div className="fieldOuter">
                                      <label htmlFor='name'>Full Name*</label>
                                      <div className="form-input-outer">
                                        <input id='name' className="form-input"  type="text" name="name" placeholder="Enter Full Name" value={this.state.name} onChange={this.handleChange}/>
                                      </div>
                                      {this.validator.message('Name', this.state.name, 'required')}
                                  </div>
                                  {/* <div className="fieldOuter">
                                      <label htmlFor='mobile'>Phone Number</label>
                                      <div className="form-input-outer">
                                        <input className="form-input" id='mobile' type="text" name="phone" placeholder="Enter Phone Number" value={this.state.phone} onChange={this.handleChange}/>
                                      </div>
                                      {this.validator.message('Mobile', this.state.phone, 'required')}
                                  </div> */}
                                  <div className="fieldOuter">
                                    <label htmlFor="phonenumber">Phone Number</label>
                                    {/*<input type="number" name="phone" onChange={this.handleChange} value={this.state.phone} placeholder="Your phone number..." />*/}
                                    {/* <div className="form-input-outer"> */}
                                    <PhoneInputField
                                      // className="form-input"
                                      id="phonenumber"
                                      placeholder="Enter Phone Number"
                                      value={this.state.phone}
                                      changeEvent={this.handlePhoneChange}
                                      // addClass="a-form-control"
                                      // addClass="contact-page"
                                    />
                                    {/* </div> */}
                                    {this.validator.message(
                                      "Enter Phone Number",
                                      this.state.phone,
                                      "required"
                                    )}
                                  </div>
                                  <div className="fieldOuter">
                                      <label>Email*</label>
                                      <div className="form-input-outer">                                      
                                        <input className="form-input" type="email" name="email" placeholder="Enter Email" value={this.state.email} onChange={this.handleChange}/>
                                      </div>
                                      {this.validator.message('Email', this.state.email, 'required')}
                                  </div>
                                  <div className="fieldOuter">
                                      <label>The location you are interested in?*</label>
                                      <div className="form-input-outer">
                                        <input className="form-input" type="text" name="location" placeholder="Enter Location" value={this.state.location} onChange={this.handleChange}/>
                                      </div>
                                      {this.validator.message('Location', this.state.location, 'required')}
                                  </div>
                                  <div className="fieldOuter">
                                      <label>Why do you want to be a part of LA?*</label>
                                      <div className="form-input-outer">
                                        <input className="form-input" type="text" name="reason" placeholder="Your Answer" value={this.state.reason} onChange={this.handleChange}/>
                                      </div>
                                      {this.validator.message('Reason', this.state.reason, 'required')}
                                  </div>
                                  {/* <div className="fieldOuter">
                                      <label>Do you have any experience in the education industry?*</label>
                                      <div className="form-input-outer">
                                      <input className="form-input" type="text" name="experience" placeholder="Your Answer" value={this.state.experience} onChange={this.handleChange}/>
                                      </div>
                                      {this.validator.message('Experience', this.state.experience, 'required')}
                                  </div> */}
                                  <div className="fieldOuter">
                                      <label>Do you have any experience in the education industry?*</label>
                                      <div className='form-radio-wrapper'>
                                          <div className="form-check">
                                            <input className="form-check-input" type="radio" 
                                            id="educationindustryY"
                                            name="educationindustry"
                                            onChange={this.handleChange}
                                            value="yes" />
                                            <label className="form-check-label" htmlFor="educationindustryY">
                                            Yes
                                            </label>
                                          </div>
                                          <div className="form-check">
                                            <input className="form-check-input" type="radio" 
                                            id="educationindustryN"
                                            name="educationindustry"
                                            onChange={this.handleChange}
                                            value="yes" />
                                            <label className="form-check-label" htmlFor="educationindustryN">
                                            No
                                            </label>
                                          </div>
                                      </div>
                                       {this.validator.message(
                                          "education industry",
                                          this.state.educationindustry,
                                          "required"
                                        )}
                                  </div>
                                  <div className="fieldOuter m-0">
                                      {!this.state.lockSubmit && <button type="submit" name="" onClick={this.submitForm} className="primary-btn" >SUBMIT <img src="/images/web-new-images/right-arrow.svg" alt="LA" /></button>}
                                      {this.state.lockSubmit && <button type="submit" name="" className="primary-btn" >Processing... <img src="/images/web-new-images/right-arrow.svg" alt="LA" /></button>}
                                  </div>
                              </div>
                            </div>
                          </div>
                      </div>
                  </div>
                </div>
                 <div className="container">
                  <div className="franchise-info-card">
                    <div className='info-icon'>
                      <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 16.875V12.875M12 8.875H12.01M22 12.875C22 18.3978 17.5228 22.875 12 22.875C6.47715 22.875 2 18.3978 2 12.875C2 7.35215 6.47715 2.875 12 2.875C17.5228 2.875 22 7.35215 22 12.875Z" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </div>
                    <p>
                      Based on the answers above, our franchising team will be in touch with you. Only apply if you want to genuinely help students achieve their dreams along with making a profit.
                    </p>
                  </div>
                </div>
              </div>
            
         
            <Footer />
            </React.Fragment>
        );
    }
}
export default Franchise;